import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
  Page,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  NamedLink, LayoutSideNavigation, LayoutWrapperAccountSettingsSideNav, InsertUserPasswordModal,
} from '../../components';
import { ProfileSettingsForm } from '../../forms';
import { TopbarContainer } from '../../containers';

import { saveEmail, updateProfile, uploadImage } from './ProfileSettingsPage.duck';
import css from './ProfileSettingsPage.css';
import { path, pathOr } from 'ramda';
import { parse } from '../../util/urlHelpers';
import { withRouter } from 'react-router-dom';
import config from '../../config.js';
import { isNilOrEmpty } from '../../util/validators';

const onImageUploadHandler = (values, fn) => {
  const { id, imageId, file } = values;
  if (file) {
    fn({ id, imageId, file });
  }
};

export class ProfileSettingsPageComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChangeEmailModalOpen: false,
      email: '',
      cniFormData: null,
      proofOfAddressFormData: null,
    };
  }

  toogleChangeEmailModalState = () => {
    this.setState((prev = {}) => ({ isChangeEmailModalOpen: !prev.isChangeEmailModalOpen}))
  };

  setCNIDocument = cniFormData => {
    this.setState({ cniFormData });
  };

  setProofOfAddressDocument = proofOfAddressFormData => {
    this.setState({ proofOfAddressFormData });
  };

  handleOnOkModalChangeEmail = (password) => {
    const { location, history } = this.props;
    const redirectOnValidate = path(['redirectOnValidate'], parse(location.search));

    this.props.onSaveEmail({ email: this.state.email, currentPassword: password }, { redirectOnValidate, history});
    this.toogleChangeEmailModalState();
  };

  handleSubmit = values => {
    const { currentUser, onUpdateProfile, location, history } = this.props;
    const user = ensureCurrentUser(currentUser);
    const { firstName, lastName, bio: rawBio, email: currentEmail, phoneNumber, birthdayDate, howDidYouKnowUs, language } = values;
    const email = pathOr('', ['attributes', 'email'], user);
    const bio = rawBio || '';
    const profile = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      bio: bio,
      protectedData: {
        phoneNumber,
        birthdayDate,
        howDidYouKnowUs,
      },
      privateData: {
        language,
      },
    };
    const uploadedImage = this.props.image;
    // Update profileImage only if file system has been accessed
    const updatedValues =
      uploadedImage && uploadedImage.imageId && uploadedImage.file
        ? { ...profile, profileImageId: uploadedImage.imageId }
        : profile;

    const emailChanged = email !== currentEmail;
    const redirectOnValidate = path(['redirectOnValidate'], parse(location.search));
    const { cniFormData, proofOfAddressFormData } = this.state;
    const documents = (cniFormData || proofOfAddressFormData) && {
      cniFormData,
      proofOfAddressFormData,
    };
    onUpdateProfile(updatedValues, documents, redirectOnValidate ? { redirectOnValidate, history } : {});

    if (emailChanged) {
      this.setState({ email: currentEmail });
      this.toogleChangeEmailModalState();
    }
  };

  render() {
    const {
      currentUser,
      image,
      onImageUpload,
      scrollingDisabled,
      updateInProgress,
      updateProfileError,
      uploadImageError,
      uploadInProgress,
      canShowCNIField,
      canShowProofOfAddress,
      intl,
      currentUserHasListings,
    } = this.props;
    const user = ensureCurrentUser(currentUser);
    const { firstName, lastName, bio } = user.attributes.profile;
    const profileImageId = user.profileImage ? user.profileImage.id : null;
    const profileImage = image || { imageId: profileImageId };
    const howDidYouKnowUs = pathOr('', ['attributes', 'profile', 'protectedData', 'howDidYouKnowUs'], user);
    const birthdayDate = pathOr('', ['attributes', 'profile', 'protectedData', 'birthdayDate'], user);
    const phoneNumberFormats = parsePhoneNumberFromString(pathOr('', ['attributes', 'profile', 'protectedData', 'phoneNumber'], user), config.locale.toUpperCase());
    const phoneNumber = isNilOrEmpty(phoneNumberFormats) ? '' : phoneNumberFormats.number;
    const email = pathOr('', ['attributes', 'email'], user);
    const language = pathOr('', ['attributes', 'profile', 'privateData', 'language'], user);
    const profileSettingsForm = user.id ? (
      <ProfileSettingsForm
        className={css.form}
        currentUser={currentUser}
        initialValues={{ firstName, lastName, bio, email, profileImage: user.profileImage, birthdayDate, howDidYouKnowUs, phoneNumber, language }}
        profileImage={profileImage}
        onImageUpload={e => onImageUploadHandler(e, onImageUpload)}
        uploadInProgress={uploadInProgress}
        updateInProgress={updateInProgress}
        uploadImageError={uploadImageError}
        updateProfileError={updateProfileError}
        onSubmit={this.handleSubmit}
        setCNIDocument={this.setCNIDocument}
        setProofOfAddressDocument={this.setProofOfAddressDocument}
        canShowCNIField={canShowCNIField}
        canShowProofOfAddress={canShowProofOfAddress}
      />
    ) : null;

    const title = intl.formatMessage({ id: 'ProfileSettingsPage.title' });

    return (
      <Page title={title} scrollingDisabled={scrollingDisabled}>
        <LayoutSideNavigation>
          <LayoutWrapperTopbar>
            <TopbarContainer currentPage="ProfileSettingsPage" />
          </LayoutWrapperTopbar>
          <LayoutWrapperAccountSettingsSideNav currentTab="ProfileSettingsPage" />
          <LayoutWrapperMain>
            <div className={css.content}>
              <div className={css.headingContainer}>
                <h1 className={css.heading}>
                  <FormattedMessage id="ProfileSettingsPage.heading" />
                </h1>
                {user.id ? (
                  <NamedLink
                    className={css.profileLink}
                    name="ProfilePage"
                    params={{ id: user.id.uuid }}
                  >
                    <FormattedMessage id="ProfileSettingsPage.viewProfileLink" />
                  </NamedLink>
                ) : null}
              </div>
              {profileSettingsForm}
              <InsertUserPasswordModal
                id="insertUserPasswordModal"
                isOpen={this.state.isChangeEmailModalOpen}
                onCloseModal={this.toogleChangeEmailModalState}
                onManageDisableScrolling={Function.prototype}
                onOkModal={this.handleOnOkModalChangeEmail}
              />
            </div>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSideNavigation>
      </Page>
    );
  }
}

ProfileSettingsPageComponent.defaultProps = {
  currentUser: null,
  uploadImageError: null,
  updateProfileError: null,
  image: null,
};

const { bool, func, object, shape, string } = PropTypes;

ProfileSettingsPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  image: shape({
    id: string,
    imageId: propTypes.uuid,
    file: object,
    uploadedImage: propTypes.image,
  }),
  onImageUpload: func.isRequired,
  onUpdateProfile: func.isRequired,
  scrollingDisabled: bool.isRequired,
  updateInProgress: bool.isRequired,
  updateProfileError: propTypes.error,
  uploadImageError: propTypes.error,
  uploadInProgress: bool.isRequired,
  currentUserHasListings: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser, requirementsToShow = {}, currentUserHasListings } = state.user;
  const { canShowCNIField, canShowProofOfAddress } = requirementsToShow;
  const {
    image,
    uploadImageError,
    uploadInProgress,
    updateInProgress,
    updateProfileError,
  } = state.ProfileSettingsPage;
  return {
    currentUser,
    image,
    scrollingDisabled: isScrollingDisabled(state),
    updateInProgress,
    updateProfileError,
    uploadImageError,
    uploadInProgress,
    canShowCNIField,
    canShowProofOfAddress,
    currentUserHasListings,
  };
};

const mapDispatchToProps = dispatch => ({
  onImageUpload: data => dispatch(uploadImage(data)),
  onUpdateProfile: (data, documents, redirectionPayload) => dispatch(updateProfile(data, documents, redirectionPayload)),
  onSaveEmail: (data, redirectionPayload) => dispatch(saveEmail(data, redirectionPayload)),
});

const ProfileSettingsPage = compose(withRouter, connect(mapStateToProps, mapDispatchToProps), injectIntl)(
  ProfileSettingsPageComponent
);

export default ProfileSettingsPage;



// WEBPACK FOOTER //
// ./src/containers/ProfileSettingsPage/ProfileSettingsPage.js